import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

export let TZ = "Europe/London";
export const setTz = (tz?: string) => { if (tz) TZ = tz; };
export const tzCity = () => TZ.split("/").pop()?.replace("_", " ") || TZ;

export const fmtTime = (iso?: string | null) => (iso ? dayjs(iso).tz(TZ).format("HH:mm:ss") : "—");
export const fmtShort = (iso?: string | null) => (iso ? dayjs(iso).tz(TZ).format("HH:mm") : "—");
export const fmtDateTime = (iso?: string | null) => (iso ? dayjs(iso).tz(TZ).format("DD MMM HH:mm") : "—");
export const fmtAgo = (iso?: string | null) => (iso ? dayjs(iso).fromNow() : "—");
export const fmtKm = (m?: number | null) => (m == null ? "—" : `${(m / 1000).toFixed(1)} km`);
export const fmtMin = (s?: number | null) => (s == null ? "—" : `${Math.round(s / 60)} min`);

export const STATUS_META: Record<string, { label: string; badge: string; hex: string }> = {
  MATCHED: { label: "Matched", badge: "bg-emerald-500/10 text-emerald-400 border border-emerald-500/20", hex: "#10B981" },
  POSSIBLE_MATCH: { label: "Possible match", badge: "bg-cyan-500/10 text-cyan-400 border border-cyan-500/20", hex: "#06B6D4" },
  NEEDS_REVIEW: { label: "Requires review", badge: "bg-amber-500/10 text-amber-400 border border-amber-500/20", hex: "#F59E0B" },
  UNMATCHED: { label: "Unmatched · review", badge: "bg-rose-500/10 text-rose-400 border border-rose-500/20", hex: "#F43F5E" },
  CANCELLED: { label: "Cancelled", badge: "bg-slate-500/10 text-slate-400 border border-slate-500/20", hex: "#64748B" },
  ACTIVE: { label: "Active", badge: "bg-blue-500/10 text-blue-400 border border-blue-500/20", hex: "#3B82F6" },
  COMPLETED: { label: "Completed", badge: "bg-slate-500/10 text-slate-300 border border-slate-500/20", hex: "#94A3B8" },
};

export const scoreColor = (score?: number | null) => {
  if (score == null) return "#64748B";
  if (score >= 85) return "#10B981";
  if (score >= 70) return "#06B6D4";
  if (score >= 50) return "#F59E0B";
  return "#F43F5E";
};

export const KIND_LABEL: Record<string, string> = {
  TRIP_JOURNEY: "Trip ↔ Journey",
  TRIP_ONLY: "Declared trip, no GPS journey",
  JOURNEY_ONLY: "GPS journey, no declared trip",
  TRIP_CANCELLED: "Cancelled trip",
};

export const DECISION_LABEL: Record<string, string> = {
  CONFIRM_LEGITIMATE: "Confirmed legitimate",
  VALID_UBER: "Valid Uber trip",
  NON_UBER: "Non-Uber journey",
  FALSE_POSITIVE: "False positive",
  REVIEWED: "Reviewed",
};
